import {
  INSTRUCTOR,
  INSTRUCTOR_DEMAND,
  ORGANIZATION_CONNECTION,
  OUTGOING_ORGANIZATION_CONNECTION_DEMAND,
} from '../reducer/instructor';
import request from '../request';
import { getAllPermissions } from './PermissionAction';

let instructorDemandURL = '/manage/instructor/registration-demands/';
let instructorURL = '/manage/instructor/profile/';
let organizationConnectionURL = '/manage/instructor/organization-connections/';
let outgoingOrganizationConnectionDemand = '/manage/instructor/outgoing-organization-connection-demands/';

/**########################## Instructor Demand Resource ##########################*/

export function instructorDemandCreate(data) {
  return async dispatch => {
    try {
      dispatch({ type: INSTRUCTOR_DEMAND.loading });

      let res = await request.post(instructorDemandURL, data);
      dispatch({ type: INSTRUCTOR_DEMAND.create, payload: res.data });
    } catch (e) {
      dispatch({ type: INSTRUCTOR_DEMAND.error, payload: e.response.data });
    }
  };
}

export function instructorDemandList(params = {}) {
  return async dispatch => {
    try {
      dispatch({ type: INSTRUCTOR_DEMAND.list.loading });

      let res = await request.get(instructorDemandURL, { params: { ...params, page_size: 5 } });
      let { results, count } = res.data;
      dispatch({ type: INSTRUCTOR_DEMAND.list.get, payload: { results, count } });
    } catch (e) {
      dispatch({ type: INSTRUCTOR_DEMAND.list.error, payload: e.response?.data });
    }
  };
}

export function instructorDemandGet(id) {
  return async dispatch => {
    try {
      dispatch({ type: INSTRUCTOR_DEMAND.loading });

      let res = await request.get(`${instructorDemandURL}${id}/`);
      dispatch({ type: INSTRUCTOR_DEMAND.get, payload: res.data });
    } catch (e) {
      dispatch({ type: INSTRUCTOR_DEMAND.error, payload: e.response.data });
    }
  };
}

export function instructorDemandUpdate(id, data) {
  return async dispatch => {
    try {
      dispatch({ type: INSTRUCTOR_DEMAND.loading });

      let res = await request.patch(`${instructorDemandURL}${id}`, data);

      dispatch({ type: INSTRUCTOR_DEMAND.update, payload: res.data });
    } catch (e) {
      dispatch({ type: INSTRUCTOR_DEMAND.error, payload: e.response.data });
    }
  };
}

/**########################## Instructor Resource ##########################*/
export function instructorGet() {
  return async dispatch => {
    try {
      dispatch({ type: INSTRUCTOR.loading });

      let res = await request.get(instructorURL);
      dispatch({ type: INSTRUCTOR.get, payload: res.data });
    } catch (e) {
      dispatch({ type: INSTRUCTOR.error, payload: e.response.data });
    }
  };
}

export function instructorUpdate(data) {
  return async dispatch => {
    try {
      dispatch({ type: INSTRUCTOR.loading });

      let res = await request.patch(instructorURL, data);
      dispatch({ type: INSTRUCTOR.update, payload: res.data });
    } catch (e) {
      dispatch({ type: INSTRUCTOR.error, payload: e.response.data });
    }
  };
}

/**########################## Organization connection resource ##########################*/
export function organizationConnectionList(params = {}) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION_CONNECTION.list.loading });

      let res = await request.get(organizationConnectionURL, { params });
      let { results, count } = res.data;
      dispatch({ type: ORGANIZATION_CONNECTION.list.get, payload: { results, count } });
    } catch (e) {
      dispatch({ type: ORGANIZATION_CONNECTION.list.error, payload: e.response.data });
    }
  };
}

export function organizationConnectionDelete(id) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION_CONNECTION.loading });

      await request.delete(`${organizationConnectionURL}${id}`);
      dispatch({ type: ORGANIZATION_CONNECTION.delete, payload: id });
    } catch (e) {
      dispatch({ type: ORGANIZATION_CONNECTION.error, payload: e.response.data });
    }
  };
}

/**########################## Outgoing Organization Connection Demand resource ##########################*/
export function outgoingOrganizationConnectionDemandList(params = {}) {
  return async dispatch => {
    try {
      dispatch({ type: OUTGOING_ORGANIZATION_CONNECTION_DEMAND.list.loading });

      let res = await request.get(outgoingOrganizationConnectionDemand, { params });
      let { results, count } = res.data;
      dispatch({ type: OUTGOING_ORGANIZATION_CONNECTION_DEMAND.list.get, payload: { results, count } });
    } catch (e) {
      dispatch({ type: OUTGOING_ORGANIZATION_CONNECTION_DEMAND.list.error, payload: e.response.data });
    }
  };
}

export function outgoingOrganizationConnectionDemandCreate(data) {
  return async dispatch => {
    try {
      dispatch({ type: OUTGOING_ORGANIZATION_CONNECTION_DEMAND.loading });

      let res = await request.post(outgoingOrganizationConnectionDemand, data);
      dispatch(getAllPermissions());
      dispatch({ type: OUTGOING_ORGANIZATION_CONNECTION_DEMAND.create, payload: res.data.organizations });
    } catch (e) {
      dispatch({ type: OUTGOING_ORGANIZATION_CONNECTION_DEMAND.error, payload: e.response.data });
    }
  };
}
